import axiosApi, { setHeader } from "api/root.api";

export const openProject = async (projectId, token) => {
  const urlEnd = `/editor/project/v1/${projectId}/publish/public`;
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd);
  const result = response.data;
  return result;
};
